module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H_Wood_MockedUp.2ba5cf69.jpg";